/**
 * Application display metadata.
 *
 * `APP_DISPLAY_NAME` is a Title-cased human name shown in the app shell heading.
 * scripts/setup-project.sh replaces the `Frontend Template Test` token here (and in index.html)
 * with the derived display name. It lives in a string literal so the ungenerated template
 * still type-checks and builds (contracts/template-generation.md).
 */
export const APP_DISPLAY_NAME = 'Frontend Template Test';
